import { useEffect, useState } from "react";
import { cn } from "../../../libs";

interface CountdownProps {
  labelClassName?: string;
  endLabelClassName?: string;
  className?: string;

  label?: string;
  endLabel?: string;
  deadline: Date | string;
}

export const Countdown: React.FC<CountdownProps> = ({
  labelClassName,
  endLabelClassName,
  className,

  label,
  endLabel,
  deadline,
}) => {
  const [timeRemaining, setTimeRemaining] = useState<{
    hours: number;
    minutes: number;
    seconds: number;
    expired: boolean;
  }>(() => {
    const expireDate = new Date(deadline);
    const now = new Date();
    const diff = expireDate.getTime() - now.getTime();

    if (diff <= 0) {
      return { hours: 0, minutes: 0, seconds: 0, expired: true };
    }

    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    return { hours, minutes, seconds, expired: false };
  });

  useEffect(() => {
    const interval = setInterval(() => {
      const expireDate = new Date(deadline);
      const now = new Date();
      const diff = expireDate.getTime() - now.getTime();

      if (diff <= 0) {
        setTimeRemaining({ hours: 0, minutes: 0, seconds: 0, expired: true });
        return;
      }

      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      setTimeRemaining({ hours, minutes, seconds, expired: false });
    }, 1000);

    return () => clearInterval(interval);
  }, [deadline]);

  if (timeRemaining.expired) {
    return (
      <p
        className={cn(
          "text-responsive-sm font-normal text-error",
          endLabelClassName
        )}
      >
        {endLabel ? endLabel : "Đã quá hạn"}
      </p>
    );
  }

  const formatTime = (value: number) => value.toString().padStart(2, "0");

  return (
    <p
      className={cn(
        "text-responsive-sm font-normal text-text-secondary",
        labelClassName
      )}
    >
      {label ? `${label}: ` : ""}
      <span className={cn("text-text-primary font-medium", className)}>
        {formatTime(timeRemaining.hours)}:{formatTime(timeRemaining.minutes)}:
        {formatTime(timeRemaining.seconds)}
      </span>
    </p>
  );
};
